module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image4_bg_mobile-def4fddeb5efb276c99cba3a244cc5e1.svg";